package ir.yusefpasha.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import ir.yusefpasha.models.Section
import ir.yusefpasha.models.Theme
import ir.yusefpasha.util.Constants
import ir.yusefpasha.util.ObserveViewportEntered
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun SectionTitle(
    modifier: Modifier = Modifier,
    section: Section,
    alignment: Alignment.Horizontal = Alignment.Start
) {

    val scope = rememberCoroutineScope()
    var titleMargin by remember { mutableStateOf(50.px) }
    var subTitleMargin by remember { mutableStateOf(50.px) }

    ObserveViewportEntered(sectionId = section.id, distanceFromTop = 700.0) {
        scope.launch {
            subTitleMargin = 0.px
            if (alignment == Alignment.Start) {
                delay(50)
            }
            titleMargin = 0.px
        }
    }

    Column(
        modifier = modifier, horizontalAlignment = alignment
    ) {
        P(
            attrs = Modifier
                .fillMaxWidth()
                .textAlign(
                    when (alignment) {
                        Alignment.CenterHorizontally -> TextAlign.Center
                        Alignment.End -> TextAlign.End
                        else -> TextAlign.Start
                    }
                )
                .margin(
                    top = 0.px,
                    bottom = 0.px,
                    left = titleMargin
                )
                .fontFamily(Constants.FONT_FAMILY)
                .fontSize(25.px)
                .fontWeight(FontWeight.Normal)
                .color(Theme.Secondary.rgb)
                .transition(CSSTransition(property = "margin", duration = Constants.ANIMATION_DURATION))
                .toAttrs()
        ) {
            Text(section.title)
        }

        P(
            attrs = Modifier
                .fillMaxWidth()
                .textAlign(
                    when (alignment) {
                        Alignment.CenterHorizontally -> TextAlign.Center
                        Alignment.End -> TextAlign.End
                        else -> TextAlign.Start
                    }
                )
                .margin(
                    top = 0.px,
                    bottom = 10.px,
                    left = if (alignment == Alignment.Start) subTitleMargin else 0.px,
                    right = if (alignment == Alignment.CenterHorizontally) subTitleMargin else 0.px
                )
                .fontFamily(Constants.FONT_FAMILY)
                .fontSize(40.px)
                .fontWeight(FontWeight.Bold)
                .color(Theme.Secondary.rgb)
                .transition(CSSTransition(property = "margin", duration = Constants.ANIMATION_DURATION))
                .toAttrs()
        ) {
            Text(section.subTitle)
        }

        Row(horizontalArrangement = Arrangement.Center) {
            Box(
                modifier = Modifier.height(2.px).width(80.px).backgroundColor(Theme.Primary.rgb).borderRadius(r = 50.px)
            )
        }
    }
}